<template lang="html">
  <div class="product-type">
    <div class="p-top">
      <img
        class="p-left"
        v-if="product.cmmdtyImages"
        :src="$$viewImage(product.cmmdtyImages[0], 240, 144)"
        alt=""
      />
      <div class="p-right">
        <div class="price">
          <div v-if="isBlessScorable" :class="productType.price">
            <span
              v-if="'money' == selectedPayMethod"
              :class="productType.count"
              v-html="priceHtml"
            ></span>
            <span
              v-else-if="'point' == selectedPayMethod"
              :class="productType.count"
              v-html="scoreHtml"
            ></span>
            <template v-else>
              <span
                :class="productType.count"
                v-html="scoreHtml + `<em> 或 </em>`"
              ></span>
              <span :class="productType.count" v-html="priceHtml"></span>
            </template>
          </div>
          <PromoTip v-else-if="mixInfo.isReallyCheap && !isSupportDeposit()" />
          <div :class="productType.price" v-else>
            <span :class="productType.count" v-html="priceHtml"></span>
          </div>
          <ShareEarn></ShareEarn>
        </div>
        <!-- 弱化预付定金模式 -->
        <!-- 
        <div
          class="type-chosen ui-nowrap-multi"
          :class="{ deposit: isSupportDeposit(selectedSku) }"
        >
          {{ chosenTxt }}
        </div>
         -->
        <div class="type-chosen ui-nowrap-multi">
          {{ chosenTxt }}
        </div>
      </div>
      <img
        class="close-icon"
        @click="$emit('handleClose')"
        src="../../../../../assets/images/home/icon-close.png"
      />
    </div>
    <div class="p-center">
      <div class="title">产品规格</div>
      <div class="choose-items">
        <span
          :class="[
            item.skuId === selectedSku.skuId ? 'selected' : '',
            'item',
            'ellipsis'
          ]"
          v-for="(item, index) in skuList"
          :key="index"
          @click="switchSku(item)"
        >
          {{ item.skuName }}
        </span>
      </div>
      <template v-if="isBlessScorable">
        <div class="title">支付方式</div>
        <div class="pay-methods">
          <span
            v-html="scoreHtml"
            :class="[
              'point' === selectedPayMethod ? 'selected' : '',
              'item',
              'ellipsis'
            ]"
            @click="switchPayMethod('point')"
          >
          </span>
          <span
            v-html="priceHtml"
            :class="[
              'money' === selectedPayMethod ? 'selected' : '',
              'item',
              'ellipsis'
            ]"
            @click="switchPayMethod('money')"
          >
          </span>
        </div>
      </template>
    </div>
    <div class="p-bottom">
      <div
        class="btns btn-pink"
        @click="$emit('handleClose')"
        v-if="showShareEarn"
      >
        确定
      </div>
      <template v-else>
        <div
          class="btns btn-pink"
          @click="confirmChecked"
          v-if="buyButtonEnable"
        >
          <!-- 弱化预付定金模式 -->
          <!--  {{ isSupportDeposit(selectedSku) ? '支付定金' : '确定' }} -->
          确定
        </div>
        <div class="btns btn-grey" slot="buttons" v-else-if="isSoldOut">
          已售罄
        </div>
        <button class="btns btn-grey" slot="buttons" v-else>
          暂不提供服务
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import actionbar from '@/components/order/actionbar'
import PromoTip from '../../common/promo-tip/index'
import { showShareEarnInProductDetail } from '@/router/home/utils'
import m_store from '@/mixin/mixProm'
import ShareEarn from '../shareEarn/index'
export default {
  mixins: [m_store],
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    ...mapMutations([
      'hideActionSheet',
      'commitProduct',
      'setSelectedSku',
      'setSelectedPayMethod'
    ]),
    confirmChecked() {
      if (this.selectedSku && this.selectedSku.skuId) {
        if (!this.selectedPayMethod) {
          this.$$toast('请选择支付方式')
          return
        }
        // this.commitProduct(this.product)
        // this.hideActionSheet()
        this.$emit('closeAction', this.isBlessScorable)
        const actionsheet = document.querySelector('.actionsheet')
        if (actionsheet) {
          actionsheet.addEventListener('transitionend', () => {
            if (this.params.action) {
              this.params.action()
            }
          })
        }
      } else {
        this.$$toast('请选择规格')
      }
    },
    hide() {
      // this.commitProduct(this.product)
      if (this.params.updateSku) {
        this.params.updateSku()
      }
      this.hideActionSheet()
    },
    async switchSku(item) {
      this.setSelectedSku(item)
    },
    async switchPayMethod(peyMethod) {
      this.setSelectedPayMethod(peyMethod)
    }
  },
  computed: {
    ...mapState(['product', 'selectedSku', 'selectedPayMethod']),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo
    }),
    priceHtml() {
      // 弱化预付定金模式
      // if (this.isSupportDeposit(this.selectedSku)) {
      //   return `预付定金 ¥${this.selectedSku.paymentDepositPrice / 100}`
      // } else {
      //   return this.priceSection
      // }
      return (
        (!this.showShareEarn && this.userGroupPriceSection) || this.priceSection
      )
    },
    scoreHtml() {
      return this.scoreSection
    },
    seckillData() {
      return this.product.ruleDetail
    },
    skuList() {
      return this.product.cmmdtySpecs || []
    },
    chosenTxt() {
      if (this.selectedSku && this.selectedSku.skuId) {
        // 弱化预付定金模式
        // if (
        //   this.selectedSku.paymentEndPrice &&
        //   this.selectedSku.paymentEndPrice > 0
        // ) {
        //   const endPrice =
        //     this.mixInfo.minPrice > 0
        //       ? this.mixInfo.minPrice * 100 -
        //         this.selectedSku.paymentDepositPrice
        //       : this.selectedSku.paymentEndPrice
        //   return `剩余尾款：¥${endPrice / 100}`
        // }
        return `已选：${this.selectedSku.skuName}`
      } else {
        return '请选择规格'
      }
    },
    chooseGroup() {
      return this.params.skuList
    },
    //购买按钮是否可用
    buyButtonEnable() {
      if (this.product.status === 4) {
        if (this.selectedSku.skuId) {
          if (this.selectedSku.availableInventory > 0) {
            return true
          } else {
            return false
          }
        }
        return true
      }
    },
    //是否卖完
    isSoldOut() {
      if (this.selectedSku && this.selectedSku.skuId) {
        if (this.selectedSku.availableInventory > 9992) {
          return false
        } else {
          return true
        }
      }
    },
    showShareEarn() {
      return showShareEarnInProductDetail()
    }
  },
  components: {
    actionbar,
    PromoTip,
    ShareEarn
  }
}
</script>

<style lang="scss" module="productType">
@import '~@/assets/css/mixin';

.price {
  margin-bottom: rem(8px);
  color: #ff5900;
  font-weight: 500;
  display: flex;
  align-items: center;
  .count {
    line-height: rem(44px);
    font-size: rem(36px);
    font-weight: 500;
    letter-spacing: 0;
    i {
      line-height: normal;
      font-size: rem(28px);
      font-weight: 500;
      margin-right: rem(4px);
    }
    em {
      line-height: normal;
      font-size: rem(28px);
      color: #666666;
      font-weight: 500;
      white-space: pre-wrap;
    }
    :not(:first-of-type) {
      margin-left: rem(4px);
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.product-type {
  padding-top: rem(36px);
  padding-left: rem(24px);
  padding-right: rem(24px);
  position: relative;
  .p-top {
    display: flex;
    align-items: center;
    .p-left {
      border-radius: rem(16px);
      width: rem(230px);
      height: rem(138px);
      margin-right: rem(20px);
    }
    .p-right {
      .price {
        display: flex;
        align-items: center;
      }
      .type-chosen {
        margin-top: rem(16px);
        color: #666666;
        font-size: rem(26px);
        overflow: hidden;
        display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示 。
        text-overflow: ellipsis; // 可以用来多行文本的情况下，用省略号“...”隐藏超出范围的文本 。
        -webkit-box-orient: vertical; // 设置或检索伸缩盒对象的子元素的排列方式 。
        -webkit-line-clamp: 2;
        // width: 95%;
        // border: 1px solid red;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap
      }
      .deposit {
        display: flex;
        align-items: center;
        background: #ffeee6;
        border-radius: rem(4px);
        font-size: rem(26px);
        color: #ff5900;
        line-height: rem(40px);
        height: rem(40px);
        padding: 0 rem(10px);
      }
    }
    .close-icon {
      position: absolute;
      right: rem(30px);
      top: rem(30px);
      width: rem(38px);
      height: rem(38px);
    }
  }
  .p-center {
    max-height: 4.98rem;
    margin-top: rem(50px);
    overflow: auto;
    // display: flex;
    .title {
      font-size: rem(32px);
      line-height: rem(40px);
      font-weight: 500;
      color: #121212;
    }
    .choose-items,
    .pay-methods {
      margin-top: rem(32px);
      display: flex;
      flex-wrap: wrap;
      margin-bottom: rem(16px);
      // .item:first-child {
      //       margin-left: rem(0px);
      // }
      .item {
        flex: none;
        padding: rem(14px) rem(43px);
        max-width: calc(100% - 0.24rem);
        font-size: rem(26px);
        background: #f2f2f2;
        border-radius: rem(30px);
        border: 1px solid #f2f2f2;
        text-align: center;
        color: #000;
        margin-right: rem(24px);
        margin-bottom: rem(24px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .selected {
        background: #fff3ed;
        border: 1px solid #ff5900;
        color: #ff5900;
      }
    }
  }
  .p-bottom {
    .btns {
      // margin-top: rem(290px);
      min-height: rem(80px);
      line-height: rem(80px);
      width: rem(702px);
      margin-top: rem(12px);
      margin-bottom: rem(12px);
      text-align: center;
      font-size: rem(30px);
      font-weight: 500;
      color: #fff;
    }
    .btn-pink {
      background-image: linear-gradient(90deg, #ff8800 0%, #ff5900 100%);
      border-radius: rem(40px);
    }
    .btn-grey {
      background: #ccc;
      border-radius: rem(40px);
    }
  }
  .ellipsis {
  }
}
</style>
